<app-actions [id]="id" type="Admin" [action]="VIEW" [service]="deleteAdmin"></app-actions>
<ng-container *ngIf="data$ | async as data">
  <app-form-group icon="one-icon-user-tooltip" title="General Information">
    <app-view-form-field label="Admin ID" [value]="id" [disabled]="true"></app-view-form-field>
    <app-view-form-field label="Email Address" [value]="data.email"></app-view-form-field>
  </app-form-group>
</ng-container>
